import { render } from "./PersonAvatarItem.vue?vue&type=template&id=481ba0f9&scoped=true&ts=true"
import script from "./PersonAvatarItem.vue?vue&type=script&lang=ts"
export * from "./PersonAvatarItem.vue?vue&type=script&lang=ts"

import "./PersonAvatarItem.vue?vue&type=style&index=0&id=481ba0f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481ba0f9"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QImg,QIcon,QTooltip,QBadge});
